var _effectorFileName = "/src/widgets/layouts/main/call-to-action/call-to-action.tsx";
import Link from 'next/link';
import { useUnit } from 'effector-react';
import { useTranslation } from 'next-i18next';
import { REVIEWS_LIST } from '@/widgets/layouts/main/constants/reviews';
import { TextShimmerAnimation } from '@/shared/components/animation/text-shimmer';
import { Article } from '@/shared/components/article';
import { ContactForm } from '@/shared/components/contact-form';
import { contactFormDataSent } from '@/shared/components/contact-form/model';
import { ContactFormData } from '@/shared/components/contact-form/types';
import { ContactModal } from '@/shared/components/contact-modal';
import ArrowIcon from '@/shared/components/icons/arrow-icon';
import HeartIcon from '@/shared/components/icons/heart-icon';
import { Marquee } from '@/shared/components/marquee';
import { TextGradient } from '@/shared/components/text-gradient';
import { Button } from '@/shared/components/ui/button';
import { cn } from '@/shared/lib/cn';
import { ReviewCard } from '../reviews/review-card';
interface CallToActionProps {
  header?: string;
  description?: string;
  link?: string;
  withForm?: boolean;
}
export const CallToAction = (props: CallToActionProps) => {
  const {
    t
  } = useTranslation(['layout-call-to-action', 'reviews']);
  const {
    header,
    description,
    link,
    withForm = false
  } = props;
  const displayHeader = header ?? t('defaultHeader');
  const displayDescription = description ?? t('defaultDescription');
  const {
    onContactFormSend
  } = useUnit({
    onContactFormSend: contactFormDataSent
  });
  const handleContactFormSubmit = (data: ContactFormData) => {
    onContactFormSend(data);
  };
  return <Article>
      <div className={cn('relative flex w-full flex-col items-center justify-center overflow-hidden rounded-xl border p-4 py-6 sm:rounded-[2rem] sm:p-10 sm:py-14', {
      '!pb-8': withForm
    })}>
        <div className="absolute rotate-[35deg]">
          <Marquee>
            {REVIEWS_LIST.map((review, index) => <ReviewCard key={index} text={t(review.text, {
            ns: 'reviews'
          })} author={{
            name: t(review.authorName, {
              ns: 'reviews'
            }),
            profession: t(review.authorProfession, {
              ns: 'reviews'
            })
          }} textClass="line-clamp-3" className="sm:shadow-sm lg:min-w-24" />)}
          </Marquee>

          <Marquee reverse>
            {REVIEWS_LIST.map((review, index) => <ReviewCard key={index} text={t(review.text, {
            ns: 'reviews'
          })} author={{
            name: t(review.authorName, {
              ns: 'reviews'
            }),
            profession: t(review.authorProfession, {
              ns: 'reviews'
            })
          }} textClass="line-clamp-3" className="sm:shadow-sm lg:min-w-24" />)}
          </Marquee>

          <Marquee>
            {REVIEWS_LIST.map((review, index) => <ReviewCard key={index} text={t(review.text, {
            ns: 'reviews'
          })} author={{
            name: t(review.authorName, {
              ns: 'reviews'
            }),
            profession: t(review.authorProfession, {
              ns: 'reviews'
            })
          }} textClass="line-clamp-3" className="sm:shadow-sm lg:min-w-24" />)}
          </Marquee>

          <Marquee reverse>
            {REVIEWS_LIST.map((review, index) => <ReviewCard key={index} text={t(review.text, {
            ns: 'reviews'
          })} author={{
            name: t(review.authorName, {
              ns: 'reviews'
            }),
            profession: t(review.authorProfession, {
              ns: 'reviews'
            })
          }} textClass="line-clamp-3" className="sm:shadow-sm lg:min-w-24" />)}
          </Marquee>

          <div className="hidden sm:block">
            <Marquee>
              {REVIEWS_LIST.map((review, index) => <ReviewCard key={index} text={t(review.text, {
              ns: 'reviews'
            })} author={{
              name: t(review.authorName, {
                ns: 'reviews'
              }),
              profession: t(review.authorProfession, {
                ns: 'reviews'
              })
            }} textClass="line-clamp-3" className="sm:shadow-sm lg:min-w-24" />)}
            </Marquee>

            <Marquee reverse>
              {REVIEWS_LIST.map((review, index) => <ReviewCard key={index} text={t(review.text, {
              ns: 'reviews'
            })} author={{
              name: t(review.authorName, {
                ns: 'reviews'
              }),
              profession: t(review.authorProfession, {
                ns: 'reviews'
              })
            }} textClass="line-clamp-3" className="sm:shadow-sm lg:min-w-24" />)}
            </Marquee>

            <Marquee>
              {REVIEWS_LIST.map((review, index) => <ReviewCard key={index} text={t(review.text, {
              ns: 'reviews'
            })} author={{
              name: t(review.authorName, {
                ns: 'reviews'
              }),
              profession: t(review.authorProfession, {
                ns: 'reviews'
              })
            }} textClass="line-clamp-3" className="sm:shadow-sm lg:min-w-24" />)}
            </Marquee>

            <Marquee reverse>
              {REVIEWS_LIST.map((review, index) => <ReviewCard key={index} text={t(review.text, {
              ns: 'reviews'
            })} author={{
              name: t(review.authorName, {
                ns: 'reviews'
              }),
              profession: t(review.authorProfession, {
                ns: 'reviews'
              })
            }} textClass="line-clamp-3" className="sm:shadow-sm lg:min-w-24" />)}
            </Marquee>
          </div>
        </div>

        <div className="z-10 grid size-24 place-items-center rounded-[2rem] border bg-white/10 p-3 shadow-2xl backdrop-blur-md dark:bg-black/10 lg:size-32">
          <HeartIcon className="h-5/6 w-5/6" />
        </div>

        <div className="z-10 mt-4 flex flex-col items-center text-center text-black dark:text-white">
          <TextGradient text={displayHeader} className="mb-1 text-2xl font-medium !tracking-tight md:text-3xl lg:text-4xl" />

          <p className="max-w-2xl text-sm sm:text-base">{displayDescription}</p>

          {!withForm && <>
              {link ? <Link href={link} aria-label={t('aria.submitRequest')}>
                  <Button size="link" className="group mt-4 flex items-center justify-center rounded-[2rem] border border-brand-accent-light bg-background px-6 text-sm font-medium shadow-sm transition-colors hover:bg-accent hover:text-accent-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50" aria-label={t('aria.submitRequest')}>
                    <TextShimmerAnimation className="flex items-center justify-center">
                      {t('buttons.writeToUs')}
                      <ArrowIcon className="ml-1 size-4 transition-all duration-300 ease-out group-hover:translate-x-1" />
                    </TextShimmerAnimation>
                  </Button>
                </Link> : <ContactModal>
                  <Button size="link" className="group mt-4 flex items-center justify-center rounded-[2rem] border border-brand-accent-light bg-background px-6 text-sm font-medium shadow-sm transition-colors hover:bg-accent hover:text-accent-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50" aria-label={t('aria.bookFreeConsultation')}>
                    <TextShimmerAnimation className="flex items-center justify-center">
                      {t('buttons.bookFreeConsultation')}
                      <ArrowIcon className="ml-1 size-4 transition-all duration-300 ease-out group-hover:translate-x-1" />
                    </TextShimmerAnimation>
                  </Button>
                </ContactModal>}
            </>}
        </div>

        {withForm && <div className="z-10 w-full">
            <ContactForm className="mx-auto mt-6 w-full max-w-3xl" customButton onFormSubmit={handleContactFormSubmit} />
          </div>}

        <div className="absolute inset-x-0 bottom-0 h-full bg-gradient-to-b from-transparent to-white to-40% dark:to-black sm:to-50%"></div>
      </div>
    </Article>;
};